import { withAsyncContext as _withAsyncContext, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

import type { SanityDocument } from "@sanity/client";


export default /*@__PURE__*/_defineComponent({
  __name: 'dpa',
  async setup(__props) {

let __temp: any, __restore: any

definePageMeta({
  layout: "default",
  pageTransition: { name: "page", mode: "out-in" },
});

useHead({
  title: "Data Protection Addendum",
  meta: [{ name: "description", content: "Data Protection Addendum FamilyAxis" }],
  bodyAttrs: {
    class: "Data Protection Addendum",
  },
});

defineOgImage("MainOg", {
  title: "Data Protection Addendum - FamilyAxis",
  description: "Understand FamilyAxis’ Data Protection Addendum.",
  theme: "#f5f5f5",
  colorMode: "light",
});

useSeoMeta({
  title: "Data Protection Addendum | FamilyAxis",
  description: "Read FamilyAxis’ Data Protection Addendum.",
  keywords: "Data Protection Addendum, FamilyAxis DPA",
  author: "FamilyAxis",
  ogTitle: "Data Protection Addendum | FamilyAxis",
  ogDescription: "Our Data Protection Addendum.",
  ogUrl: "https://familyaxis.com/dpa",
  ogType: "website",
  ogSiteName: "FamilyAxis",
  twitterCard: "summary_large_image",
  twitterTitle: "Data Protection Addendum | FamilyAxis",
  twitterDescription: "Read our Data Protection Addendum.",
  twitterSite: "@familyaxis",
  robots: "index, follow",
});

const POST_QUERY = groq`*[_type == "page" && slug.current == "dpa"][0]`;
const { data: post } = (
  ([__temp,__restore] = _withAsyncContext(() => useSanityQuery<SanityDocument>(POST_QUERY))),
  __temp = await __temp,
  __restore(),
  __temp
);

return (_ctx: any,_cache: any) => {
  const _component_UPageHero = _resolveComponent("UPageHero")!
  const _component_ContentSanity = _resolveComponent("ContentSanity")!
  const _component_UPage = _resolveComponent("UPage")!
  const _component_UContainer = _resolveComponent("UContainer")!

  return (_openBlock(), _createBlock(_component_UContainer, null, {
    default: _withCtx(() => [
      _createVNode(_component_UPage, { class: "prose px-5 md:px-32 dpa" }, {
        default: _withCtx(() => [
          _createVNode(_component_UPageHero, {
            title: "Data Protection Addendum",
            description: `Last updated: ${_ctx.formatDateString(_unref(post)._updatedAt)}`
          }, null, 8, ["description"]),
          (_unref(post).body)
            ? (_openBlock(), _createBlock(_component_ContentSanity, {
                key: 0,
                blocks: _unref(post).body,
                page: "dpa"
              }, null, 8, ["blocks"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})